import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Avatar from '#components/a/Avatar'
import MilestoneNotificationIcon from '#components/svg/icons/MilestoneNotificationIcon'
import StyledText from '#components/a/StyledText'
import {routeHelper} from '#config/routeKeys'

export class AusbildungEndetBenachrichtigung extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick, senderId} = this.props
    onNotificationClick(routeHelper.praxisaufgabenDetail(senderId))
  }

  render() {
    const {userInfo} = this.props
    const text = i18n.t('notification_text_ausbildung_endet', [`${userInfo.lastname}, ${userInfo.firstname}`])

    return (
      <div
        role="button"
        tabIndex={0}
        className="notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}
      >
        <Avatar profileImage={userInfo.profileImage} />
        <StyledText text={text} modifier="notification" />
        <div className="notification__icon notification__icon--right">
          <MilestoneNotificationIcon />
        </div>
      </div>
    )
  }
}

AusbildungEndetBenachrichtigung.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  senderId: PropTypes.number,
  onNotificationClick: PropTypes.func.isRequired,
}

export default UserInfoHOC(AusbildungEndetBenachrichtigung, ['senderId'])
